const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/teams/members/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import i18n from '@/lib/translations/i18n';
import { BOOLEAN_FILTER_REGEX, PICKLIST_FILTER_REGEX } from '@/lib/utils/insights/compact-filters/filterOperators';
const compactPicklistFilterSchema = z.string().regex(PICKLIST_FILTER_REGEX, 'Invalid picklist filter format. Expected: operator_value1-value2 (e.g., in_50 or in_30-34)').optional();
const compactBooleanFilterSchema = z.string().regex(BOOLEAN_FILTER_REGEX, 'Invalid boolean filter format. Expected: operator_value (e.g., is_true or is_false)').optional();
export const teamMembershipSearchSchema = z.object({
  locationId: compactPicklistFilterSchema,
  showDeactivatedMembers: compactBooleanFilterSchema
});
export const Route = createFileRoute('/(app)/org/$org/teams/members/')({
  validateSearch: teamMembershipSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t('common.people')
    }
  }
});